import axios from 'axios';
import { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';


export default function AuthUser() {
    const navigate = useNavigate();

    const getToken = () => {
        const tokenString = localStorage.getItem('token');
        const userToken = JSON.parse(tokenString);
        return userToken;
    }

    const getUser = () => {
        const userString = localStorage.getItem('user');
        const user_detail = JSON.parse(userString);
        return user_detail;
    }

    const [token, setToken] = useState(getToken());
    const [user, setUser] = useState(getUser());
    // 🔄 Sync state with session storage when the component mounts



    const saveToken = (user, token) => {
        setToken(token);
        setUser(user);

        localStorage.setItem('token', JSON.stringify(token));
        localStorage.setItem('user', JSON.stringify(user));

        setToken(token);
        setUser(user);


        // ✅ Handle redirect after login
        const redirectPath = localStorage.getItem("redirectAfterLogin") || "/";
        localStorage.removeItem("redirectAfterLogin");
        navigate(redirectPath);

    }

    const logout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        sessionStorage.removeItem('ticket_email');
        sessionStorage.removeItem('ticket_data');

        setToken(null); // Ensure React state updates
        setUser(null);

        navigate('/login');
    }

    const http = axios.create({
        baseURL: `${process.env.REACT_APP_API_URL}/api`,
        headers: {
            "Content-type": "application/json",
            "Authorization": `Bearer ${token}`
        }
    });

    return {
        setToken: saveToken,
        token,
        user,
        getToken,
        http,
        logout
    }
}
